import { render } from "./country-select.vue?vue&type=template&id=32ca8b5d"
import script from "./country-select.vue?vue&type=script&lang=js"
export * from "./country-select.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__